import { RecommendationsBySku } from "../../../Interfaces/Product";

const recommendations_by_sku: RecommendationsBySku = {
  "101": [102, 103, 104],
  "102": [101, 103, 104],
  "103": [101, 102, 104],
  "104": [101, 102, 103],
  "105": [101, 102, 103],
  "106": [101, 102, 103],
  "107": [108, 109, 110],
  "108": [107, 109, 110],
  "109": [107, 108, 110],
  "110": [101, 102, 103],
  "111": [101, 102, 103],
  "112": [101, 102, 103],
  "113": [101, 110, 112],
  "114": [101, 110, 112],
  "115": [101, 102, 103],
  "116": [101, 102, 103],
  "118": [101, 102, 103],
  "119": [101, 102, 103],
  "120": [101, 110, 112],
  "121": [101, 110, 112],
  "122": [101, 110, 112],
  "123": [101, 110, 112],
  "124": [101, 102, 103],
  "125": [101, 110, 112],
  "126": [101, 110, 112],
  "127": [101, 102, 103],
  "128": [101, 102, 103],
  "129": [101, 102, 103],
  "130": [101, 102, 103],
  "131": [101, 102, 103],
  "132": [101, 102, 103],
  "133": [101, 102, 103],
  "134": [101, 102, 103],
  "201": [202, 203, 204],
  "202": [201, 203, 204],
  "203": [201, 202, 204],
  "204": [201, 202, 203],
  "205": [201, 202, 203],
  "206": [201, 202, 203],
  "207": [201, 202, 203],
  "208": [201, 202, 203],
  "209": [201, 202, 203],
  "210": [201, 202, 203],
  "211": [201, 202, 203],
  "212": [201, 202, 203],
  "301": [302, 303, 304],
  "302": [101, 102, 103],
  "303": [301, 302, 304],
  "304": [101, 102, 103],
  "450": [452, 454, 456],
  "452": [450, 454, 456],
  "454": [450, 452, 456],
  "456": [450, 452, 454],
  "458": [450, 452, 454],
  "460": [450, 452, 454],
  "476": [478, 480, 482],
  "478": [476, 480, 482],
  "480": [476, 478, 482],
  "482": [476, 478, 480],
  "484": [476, 478, 480],
  "486": [476, 478, 480],
  "501": [],
  "550": [551, 552, 553],
  "551": [550, 552, 553],
  "552": [550, 551, 553],
  "553": [550, 551, 552],
  "555": [550, 551, 552],
  "556": [550, 551, 552],
  "601": [602, 603, 604],
  "602": [601, 603, 604],
  "603": [601, 602, 604],
  "604": [601, 602, 603],
  "605": [601, 602, 603],
  "651": [652, 653, 654],
  "652": [651, 653, 654],
  "653": [651, 652, 654],
  "654": [651, 652, 653],
  "655": [651, 652, 653],
  "656": [651, 652, 653],
  "701": [705],
  "705": [701],
  "106001": [101, 102, 103],
  "107001": [107, 108, 109],
  "108001": [107, 108, 109],
  "109001": [107, 108, 109],
  "116001": [101, 102, 103],
  "118001": [101, 102, 103],
};

export default recommendations_by_sku;
